<script>
export default {
  name: 'Student',
  data() {
    return {
      student: null,
      guardian: null,
      location: null,
      startDate: null,
      originalStartDate: null,
      infoLists: [
        {
          title: 'Basics',
          items: [
            {
              title: 'Remaining Credits',
              data: () => this.student.class_credits,
            },
            {
              title: 'Start Date',
              data: () => this.startDate ? this.$buildDate(this.startDate.date, '{shortMonth} {longDate}, {year}') : 'N/A',
              onClick: () => this.editField('class-picker', 'start_date_class_id'),
            },
            {
              title: 'Location',
              data: () => this.location.display_name,
            },
            {
              title: 'Birthday',
              data: () => this.student.birthday,
            },
            {
              title: 'Ethnicity',
              data: () => this.student.ethnicity,
            },
            {
              title: 'Gender',
              data: () => this.student.gender,
            },
            {
              title: 'Original Start Date',
              data: () => this.originalStartDate ? this.$buildDate(this.originalStartDate.date, '{shortMonth} {longDate}, {year}') : 'N/A',
            },
          ],
        },
        {
          title: 'Guardian',
          items: [
            {
              title: 'Name',
              data: () => this.guardian.name,
            },
            {
              title: 'Phone',
              data: () => this.guardian.phone,
            },
            {
              title: 'Email',
              data: () => this.guardian.email,
            },
            {
              title: 'Application Status',
              data: () => this.guardian.application_status,
            },
            {
              title: 'Agreed to Policy and Conduct',
              data: () => this.$buildDate(this.guardian.agreed_to_conduct_and_discipline_policy, '{shortMonth} {longDate}, {year}'),
            },
          ],
        },
        {
          title: 'Paperwork',
          seeIf: () => this.student.paperwork_complete,
          items: [
            {
              title: 'Address',
              data: () => this.student.paperwork.address,
            },
            {
              title: 'Student Phone',
              data: () => this.student.paperwork.phone,
            },
            {
              title: 'Allergies',
              data: () => this.student.paperwork.allergies,
            },
            {
              title: 'Allowed Pickup #1',
              data: () => {
                const pu = this.student.paperwork.allowed_pickups[0]
                return ['name', 'relationship', 'phone']
                  .map(field => pu[field]).join('<br/>')
              },
            },
            {
              title: 'Allowed Pickup #2',
              data: () => {
                const pu = this.student.paperwork.allowed_pickups[1]
                return ['name', 'relationship', 'phone']
                  .map(field => pu[field]).join('<br/>')
              },
            },
            {
              title: 'Emergency Comments',
              data: () => this.student.paperwork.emergency_comments,
            },
            {
              title: 'Photo Release',
              data: () => this.student.paperwork.media_released ? 'done' : 'clear',
              icon: true,
              style: () => ({color: this.student.paperwork.media_released ? 'green' : 'red'}),
            },
            {
              title: 'Primary Contact',
              data: () => {
                const pc = this.student.paperwork.primary_contact
                return `${pc.name}<br />
                  ${pc.relationship}<br />
                  Cell: ${pc.cell_phone}<br />
                  Home: ${pc.home_phone}<br />
                  Work: ${pc.work_phone}`
              },
            },
            {
              title: 'Secondary Contact',
              data: () => {
                const sc = this.student.paperwork.secondary_contact
                return `${sc.name}<br />
                  ${sc.relationship}<br />
                  Cell: ${sc.cell_phone}<br />
                  Home: ${sc.home_phone}<br />
                  Work: ${sc.work_phone}`
              },
            },
            {
              title: 'Self Sign Out',
              data: () => this.student.paperwork.self_signout ? 'done' : 'clear',
              icon: true,
              style: () => ({color: this.student.paperwork.self_signout ? 'green' : 'red'}),
            },
          ],
        },
      ],
    }
  },
  computed: {
    studentId () {
      return this.$route.params.studentId 
    },
  },
  methods: {
    async getStudentInfo () {
      const getEntity = (collection, docId) => new Promise(async resolve => resolve((await this.$firestore.collection(collection).doc(docId).get()).data()))
      const student = await getEntity('users', this.studentId)
      this.guardian = await getEntity('users', student.guardian_id)
      this.location = await getEntity('locations', this.guardian.location_id)
      this.startDate = await getEntity('classes', student.start_date_class_id)
      if (student.original_start_date_class_id) {
        this.originalStartDate = await getEntity('classes', student.original_start_date_class_id)
      }
      this.student = student
    },
    showPaperworkModal () {
      this.$modals.show({
        name: 'paperwork',
        guardianId: this.student.guardian_id,
        onSuccess: this.getStudentInfo,
      })
    },
    editField (modalName, field) {
      this.$modals.show({
        name: modalName,
      })
    },
  },
  mounted () {
    this.getStudentInfo()
  },
}
</script>

<template lang="pug">
  #student-main
    .student-container
      .title.font-1-bold {{student ? student.name : 'Loading...'}}
      .paperwork-warning(
        v-if='student && !student.paperwork_complete'
        @click='showPaperworkModal'
      )
        .warning-title ACTION REQUIRED
        .warning-content
          .copy Please click here to complete student's paperwork. Paperwork must be completed before the first day of class.
      .content(
        v-if='student'
      )
        .student-info-holder
          .info-list(
            v-for='list in infoLists'
            v-if='!list.seeIf || list.seeIf()'
          )
            .info-list-title.font-1-bold {{list.title}}
            .info-line(
              v-for='info in list.items'
              @click='() => info.onClick ? info.onClick() : ""'
            )
              .info-title(
                v-html='info.title'
              )
              .info-data(
                v-html='info.icon ? `<i class="material-icons">${info.data()}</i>` : info.data()'
                :style='info.style ? info.style() : {}'
              )


</template>

<style lang="sass" scoped>
  #student-main
    .student-container
      .title
        font-size: 36px
      .paperwork-warning
        padding: 16px
        cursor: pointer
        background-color: transparentize($red, .4)
        color: white
        margin: 16px 0 0
        width: fit-content
        max-width: 400px
        border-radius: 8px
        .warning-title
          @extend .font-1-bold
          font-size: 24px
      .content
        padding: 48px 0 24px
        .student-info-holder
          .info-list
            margin: 0 104px 56px 32px
            width: max-content
            .info-list-title
              font-size: 24px
            .info-line
              display: grid
              grid-template-columns: 240px auto
              padding: 16px 0
              font-size: 16px
              cursor: pointer
              position: relative
              &:hover
                &:after
                  font-family: 'Material Icons'
                  content: 'edit'
                  position: absolute
                  right: -64px
                  top: 16px
              .info-title
                justify-self: end
                padding-right: 16px
                color: #666
</style>